module.exports = __webpack_public_path__ + "static/media/ig-icon-mobile.a5f50174.svg";